import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = _resolveComponent("router-view");
    const _component_modal_edicao_meu_perfil = _resolveComponent("modal-edicao-meu-perfil");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_router_view),
        _createVNode(_component_modal_edicao_meu_perfil)
    ], 64));
}
